// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterUserStatusesWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterUserStatusesWebApiHandler_getUserStatuses,
  CappsRenterUserStatusesWebApiHandler_getUserStatuses_Path,
} from '@zg-rentals/ts-capps-client';

import type { GetUserStatusesWebApiResponseDto } from '@zg-rentals/ts-capps-client';

export type CappsRenterUserStatusesWebApiHandler_getUserStatuses_Options = UseQueryOptions<
  GetUserStatusesWebApiResponseDto,
  unknown,
  GetUserStatusesWebApiResponseDto,
  readonly [string]
>;

const CappsRenterUserStatusesWebApiHandler_getUserStatuses_GetKey = () =>
  [CappsRenterUserStatusesWebApiHandler_getUserStatuses_Path] as const;

export const CappsRenterUserStatusesWebApiHandler_getUserStatuses_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterUserStatusesWebApiHandler_getUserStatuses_GetKey(),
    queryFn: () => CappsRenterUserStatusesWebApiHandler_getUserStatuses(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterUserStatusesWebApiHandler_getUserStatuses = ({
  httpClient,
  ...options
}: Omit<CappsRenterUserStatusesWebApiHandler_getUserStatuses_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsRenterUserStatusesWebApiHandler_getUserStatuses_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsRenterUserStatusesWebApiHandler_getUserStatuses.getKey =
  CappsRenterUserStatusesWebApiHandler_getUserStatuses_GetKey;
